import { Vue, Component } from 'vue-property-decorator'
import GrossingTouchSidepanelWrapper from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-sidepanel-wrapper/grossing-touch-sidepanel-wrapper.vue'
import VtBubble from '@/components/common/VtBubble.vue'

@Component({
    components: {
        GrossingTouchSidepanelWrapper,
        VtBubble
    }
})

export default class GrossingTouchPatientSidepanel extends Vue {
}
